import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function TestRoute() {
  const [count, setCount] = useState(0);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Test Route</h1>
        <p className="text-muted-foreground">
          This is a test page to verify routing is working
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Route Test</CardTitle>
        </CardHeader>
        <CardContent>
          <p>If you can see this page, routing is working correctly!</p>
          <div className="mt-4">
            <p>Counter: {count}</p>
            <Button
              onClick={() => {
                setCount(count + 1);
              }}
              className="mt-2"
            >
              Increment
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
